import { Row, Col } from "antd";
import { AntdTab } from "../../../../../components";
import NewGuest from "./NewGuest/NewGuest";
import ImportGuests from "./ImportGuest/ImportGuest";
import LinkGuest from "./LinkGuest/LinkGuest";
import styles from "./AddGuest.module.css";

const items = [
  {
    key: "1",
    label: "Add new Guest",
    children: (
      <div className={styles.container}>
        <NewGuest />
      </div>
    ),
  },
  // {
  //   key: "2",
  //   label: "Import Guests",
  //   children: <ImportGuests />,
  // },
  {
    key: "3",
    label: "Send a link to Guests",
    children: <LinkGuest />,
  },
];

const AddGuest = () => {
  return (
    <>
      <AntdTab items={items} />
    </>
  );
};

export default AddGuest;
